/*
  通用方法
  全局使用
 */

// 用于异步延时
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export {
  sleep
}


// WEBPACK FOOTER //
// ./src/utils/funcset.js